import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {

    private majorLoading = true;

    private minorLoading = true;

    public setMajorLoading() {
        this.majorLoading = true;
    }

    public unsetMajorLoading() {
        this.majorLoading = false;
    }

    public setMinorLoading() {
        this.minorLoading = true;
    }

    public unsetMinorLoading() {
        this.minorLoading = false;
    }

    get isMajorLoading() {
        return this.majorLoading;
    }

    get isMinorLoading() {
        return this.minorLoading;
    }

}
